import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundJob } from 'utils/BackgroundJobs';
import { PurchaseOrderDocument } from 'graphql/entities';

import { getMutationProps, getRangeMutationProps } from './DocumentAction';
import { onDocumentComplete, onDocumentPrintFailed } from '../../utils/DocumentUtils';

function onComplete(state, props, job) {
  const { overrideOutput, outputType, showSummary } = state;
  const { dispatch, onClose, onComplete, onProcessSummary, onProcessPreview } = props;

  onDocumentComplete({
    overrideOutput,
    outputType,
    documentName: 'Purchase Order',
    dispatch,
    onClose: () => onClose(false, state, props, job),
    onComplete,
    showSummary,
    onProcessSummary: () => onProcessSummary(false, state, props, job),
    onProcessPreview,
    job,
  });
}

export function generate(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    PurchaseOrderDocument.generate,
    getMutationProps(state, props, variables),
    props,
    returnUrl,
    'Generate Purchase Order Document',
    (job) => onComplete(state, props, job)
  );
}

export function generateRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;
  createBackgroundJob(
    PurchaseOrderDocument.generateRange,
    getRangeMutationProps(state, props, variables, 'purchaseOrders'),
    props,
    returnUrl,
    'Generate Purchase Order Document',
    (job) => onComplete(state, props, job),
    (job) => onDocumentPrintFailed(state, props, job)
  );
}

/**
 * Reprints a set of acknowledgements (Provided as an array within variables).
 */
export function reprintRange(state, props, variables, returnUrl) {
  if (hasValidationErrors(props)) return;

  createBackgroundJob(
    PurchaseOrderDocument.reprint,
    getRangeMutationProps(state, props, variables, 'purchaseOrderDocuments'),
    props,
    returnUrl,
    'Generate Purchase Order Document',
    (job) => onComplete(state, props, job)
  );
}
